var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { AngleRight } from '@mehilainen/mds-icons';
import { radius } from '@mehilainen/mds-tokens';
import { Gray100, Gray200, Gray900, Primary100, Primary500, } from '@mehilainen/mds-tokens/colors';
import { spacing } from '@mehilainen/mds-tokens/spacing';
import { baseTypography } from '@mehilainen/mds-tokens/typography';
import { Box, Stack, styled } from '@mui/material';
import { forwardRef } from 'react';
import { shouldForwardProp } from '../mds-shared';
const Container = styled(Box)({
    display: 'flex',
    alignItems: 'center',
    backgroundColor: 'unset',
    border: 0,
    borderRadius: radius[200].px,
    color: Gray900,
    gap: spacing[300].px,
    padding: spacing[300].px,
    textAlign: 'left',
    textDecoration: 'none',
    '&:is(a)': {
        cursor: 'pointer',
    },
    '&:hover': {
        backgroundColor: Gray100,
        textDecoration: 'underline',
    },
    '&:active': {
        backgroundColor: Gray200,
    },
});
// MUI reference: https://mui.com/material-ui/migration/upgrade-to-v6/#box
const startIconSizeMap = {
    medium: {
        fontSize: baseTypography.size.icon[300].rem,
    },
    small: {
        fontSize: baseTypography.size.icon[200].rem,
    },
};
const StartIcon = styled(Stack, { shouldForwardProp })(({ $size }) => ({
    '& > svg': Object.assign({ color: Primary500 }, startIconSizeMap[$size]),
}));
const titleSizeMap = {
    medium: {
        fontSize: baseTypography.size[400].rem,
    },
    small: {
        fontSize: baseTypography.size[300].rem,
    },
};
const Title = styled(Stack, { shouldForwardProp })(({ $size }) => (Object.assign({ flex: 1, fontWeight: baseTypography.weight.Medium, lineHeight: baseTypography.height.Medium, overflowWrap: 'anywhere' }, titleSizeMap[$size])));
const endIconSizeMap = {
    medium: {
        fontSize: baseTypography.size.icon[500].rem,
    },
    small: {
        fontSize: baseTypography.size.icon[300].rem,
    },
};
const EndIcon = styled(Stack, { shouldForwardProp })(({ $size }) => ({
    '& > svg': Object.assign({ color: Primary500 }, endIconSizeMap[$size]),
    backgroundColor: Primary100,
    borderRadius: radius[200].px,
}));
const defaultProps = {
    component: 'a',
    size: 'medium',
};
/**
 * ListItem component
 *
 *  @param children - The content of the component
 *  @param component - The component used for the root node
 *  @param size - Component size variant
 *  @param startIcon - Icon component
 */
export const ListItem = forwardRef((props, ref) => {
    const { children, component = defaultProps.component, size = defaultProps.size, startIcon } = props, otherProps = __rest(props, ["children", "component", "size", "startIcon"]);
    return (_jsxs(Container, Object.assign({ component: component }, otherProps, { ref: ref, children: [!!startIcon && _jsx(StartIcon, { "$size": size, children: startIcon }), _jsx(Title, { "$size": size, children: children }), _jsx(EndIcon, { "$size": size, children: _jsx(AngleRight, {}) })] })));
});
